import 'slick-carousel';

const $sliderMixed = $('.js-slider-billboards-mixed');
const $slider = $('.js-slider-billboards');

const $video = $sliderMixed.find('iframe');
const $videoAlt = $slider.find('iframe');

const handleBillboardSliders = () => {

	$slider.each(function(index, el) {
		const $this = $(this);
		const $slides = $this.find('.slider__slides');

		$slides.on('init', function(event, slick, currentSlide) {
			const $activeSlide = $slides.find('.slick-current');
			const $target = $activeSlide.find('.slider__slide');
			const $iframe = $activeSlide.find('iframe');

			playPauseVideo($target, 'play');

			setTimeout(() => {
				$slides.slick('slickGoTo', 0);

				$iframe.length === 1 ? $slides.slick('slickPause') : $slides.slick('slickPlay');
			}, 10)
		});

		$slides.on('beforeChange', function(event, slick, currentSlide) {
			const $activeSlide = $slides.find('.slick-current');
			const $target = $activeSlide.find('.slider__slide');

			playPauseVideo($target, 'pause');
		});

		$slides.on('afterChange', function(event, slick, currentSlide) {
			const $activeSlide = $slides.find('.slick-current');
			const $target = $activeSlide.find('.slider__slide');
			const $iframe = $activeSlide.find('iframe');

			playPauseVideo($target, 'play');

			if ($iframe === undefined) {
				return
			}

			$iframe.length === 1 ? $slides.slick('slickPause') : $slides.slick('slickPlay');
		});

		$slides.slick({
			infinite: true,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  dots: true,
		  arrows: false,
		  autoplay: false,
		  pauseOnHover: false,
		  adaptiveHeight: true
		});
	});
};

handleBillboardSliders();

const handleNixedBillboardSlider = () => {
	$sliderMixed.each(function(index, el) {
		const $this = $(this);
		const $slides = $this.find('.slider__slides');

		$slides.on('init', function(event, slick, currentSlide) {
			const $activeSlide = $slides.find('.slick-current');
			const $target = $activeSlide.find('.slider__slide');

			playPauseVideo($target, 'play');

			setTimeout(() => {
				$slides.slick('slickGoTo', 0);
				const $iframe = $activeSlide.find('iframe');

				$iframe.length === 1 ? $slides.slick('slickPause') : $slides.slick('slickPlay');
			}, 10)
		});

		$slides.on('beforeChange', function(event, slick, currentSlide) {
			const $activeSlide = $slides.find('.slick-current');
			const $target = $activeSlide.find('.slider__slide');
			const $iframe = $activeSlide.find('iframe');

			playPauseVideo($target, 'pause');
		});

		$slides.on('afterChange', function(event, slick, currentSlide) {
			const $activeSlide = $slides.find('.slick-current');
			const $target = $activeSlide.find('.slider__slide');
			const $iframe = $activeSlide.find('iframe');

			playPauseVideo($target, 'play');

			$iframe.length === 1 ? $slides.slick('slickPause') : $slides.slick('slickPlay');
		});

		$slides.slick({
		  infinite: true,
		  autoplaySpeed: 5000,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  dots: true,
		  arrows: true,
		  autoplay: false,
		  pauseOnHover: false,
		  adaptiveHeight: true
		})
	});
};

handleNixedBillboardSlider();

function playPauseVideo($activeSlide, control) {
	let slideType;
  	let player;
  	let video;

  	slideType = $activeSlide.attr('class').split(' ')[1];
  	player = $activeSlide.find('iframe').get(0);

  	if (slideType === 'youtube') {
    	switch (control) {
      		case 'play':
	        	// Always start the video from the beginning when its billboard comes into view
	        	postMessageToPlayer(player, {
	          		event: 'command',
			        func: 'seekTo',
			        args: [0, true]
	        	});
	        	postMessageToPlayer(player, {
	          		event: 'command',
			        func: 'mute'
	        	});
		        postMessageToPlayer(player, {
	          		event: 'command',
	          		func: 'playVideo'
	        	});
        	break;
      		case 'pause':
		        postMessageToPlayer(player, {
		          	event: 'command',
		          	func: 'pauseVideo'
		        });
		        postMessageToPlayer(player, {
	          		event: 'command',
			        func: 'mute'
	        	});
        	break;
    	};
  	}
};

function postMessageToPlayer(player, command) {
	if (player == null || player == undefined || command == null) return;
  	player.contentWindow.postMessage(JSON.stringify(command), "*");
};
